import styled, { css } from 'styled-components';
import { colorVariables } from 'theme/variables';

export const PasswordInputStyled = styled.div`
  position: relative;
`;

export const StyledStrength = styled.div`
  position: relative;
  height: 1px;
  width: 0;
  top: -1px;
  left: 3px;
  background: ${colorVariables.red_bright};
  transition:
    width 0.2s ease-out,
    background-color 0.2s ease-out;

  ${(props) => {
    switch (true) {
      case props.passwordStrength === 'strong':
        return css`
          background: ${colorVariables.green_light};
          width: calc(100% - 5px);
        `;
      case props.passwordStrength === 'medium':
        return css`
          background: ${colorVariables.yellow_dark};
          width: 50%;
        `;
      case props.passwordStrength === 'short':
        return css`
          background: ${colorVariables.red_bright};
          width: 33.3333%;
        `;
      default:
        return false;
    }
  }};
`;
